import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import {useTheme} from '@material-ui/core/styles';

const EmailIcon = ({primary, ...props}) => {
  const theme = useTheme();
  const fill = primary
    ? theme.palette.primary.main
    : theme.palette.common.white;

  return (
    <SvgIcon
      {...props}
      width="30.188"
      height="22.641"
      viewBox="0 0 30.188 22.641"
    >
      <path
        fill={fill}
        d="M27.357,59.882H2.83A2.833,2.833,0,0,0,0,62.712v16.98a2.833,2.833,0,0,0,2.83,2.83H27.357a2.833,2.833,0,0,0,2.83-2.83V62.712A2.833,2.833,0,0,0,27.357,59.882Zm0,1.887a.938.938,0,0,1,.362.073L15.094,72.784,2.468,61.842a.939.939,0,0,1,.362-.073Zm0,18.867H2.83a.944.944,0,0,1-.943-.943V63.835l12.589,10.91a.945.945,0,0,0,1.236,0L28.3,63.835V79.693A.944.944,0,0,1,27.357,80.636Z"
        transform="translate(0 -59.882)"
      />
    </SvgIcon>
  );
};

export default EmailIcon;
